import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { POOL_PREFIX_PATH } from 'configs/AppConfig'

export const PoolViews = () => {
  return (
    <Suspense fallback={<Loading cover="page"/>}>
      <Switch>
      <Route path={`${POOL_PREFIX_PATH}/sign`} component={lazy(() => import(`./sign/index`))} />
      <Route path={`${POOL_PREFIX_PATH}/register-access`} component={lazy(() => import(`./registerAccess/index`))} />
      <Route path={`${POOL_PREFIX_PATH}/error`} component={lazy(() => import(`./errors/error-page`))} />
        <Redirect from={`${POOL_PREFIX_PATH}`} to={`${POOL_PREFIX_PATH}/error`} />
      </Switch>
    </Suspense>
  )
}

export default PoolViews;

